import React, {useState} from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import {sortById} from '../util/SortingFunctions';
import {Delete} from '@mui/icons-material';
import AlertDialog from './dialogs/alertDialog';
import {deleteRef} from '../util/FileUtils';
import * as Sentry from '@sentry/react';
import AttachmentIcon from '@mui/icons-material/Attachment';

function DocumentsList(props: $TSFixMe) {
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [selectedFile, setSelectedFile] = useState<any>(null);

  const truncate = (name: $TSFixMe) =>
    name.length > 16 ? `${name.substring(0, 16)}...` : name;

  const documentItem = (doc: $TSFixMe) => {
    const title = truncate(doc.name);

    const handleClickDeleteDocument = (document: $TSFixMe) => {
      setSelectedFile(document);
      setDeleteDocument(true);
    };

    return (
      <Grid item key={doc.id} style={{marginRight: 8}}>
        <Grid
          container
          direction="column"
          alignItems="center"
          style={{position: 'relative'}}>
          <Link href={doc.url} target="_blank" rel="noopener">
            <div
              style={{
                textAlign: 'center',
              }}>
              <AttachmentIcon />
              <br />
              <Typography variant="caption">{title}</Typography>
            </div>
          </Link>
          {props.editable && (
            <IconButton onClick={() => handleClickDeleteDocument(doc)}>
              <Delete color="primary" fontSize="small" />
            </IconButton>
          )}
        </Grid>
      </Grid>
    );
  };

  const handleDeleteFile = () => {
    deleteRef(selectedFile)
      .then((res) => res.text())
      .then((res) => {
        // look for index in array where id matches selectedFile id
        const targetIndex = props.attachmentReferences.findIndex(
          (x: $TSFixMe) => x.id === selectedFile.id,
        );
        // remove entry from attachment array
        props.attachmentReferences.splice(targetIndex, 1);
        setDeleteDocument(false);
        props.updateRequestForProposalState &&
          props.updateRequestForProposalState();
      })
      .catch((err) => {
        process.env.NODE_ENV === 'development' && console.error(err);
        Sentry.withScope(function (scope) {
          scope.setTag('section', 'DocumentsList.tsx handleDeleteFile()');
          Sentry.captureException(err);
        });
      });
  };

  return (
    <Box mb={1}>
      <Grid container direction="row" spacing={1}>
        {props.attachmentReferences
          .filter((doc: $TSFixMe) =>
            [
              'project_document',
              'business_document',
              'messaging_attachment',
              'fees_invoice',
              'payment_receipt',
              'contractor_payment_receipt',
            ].includes(doc.key),
          )
          .sort(sortById)
          .map((doc: $TSFixMe, index: $TSFixMe) => documentItem(doc))}
      </Grid>
      <div>
        <AlertDialog
          open={deleteDocument}
          title="Confirm deletion"
          body="Are you sure you want to delete this file?"
          confirm="DELETE"
          close="CANCEL"
          onConfirm={handleDeleteFile}
          onClose={() => setDeleteDocument(false)}
          deletion
        />
      </div>
    </Box>
  );
}

export default DocumentsList;
